import { Helmet } from "react-helmet-async";
import { slider2 } from "../../../assets/data/Imagedata";
import seoData from "../../../assets/data/seo.json";
import LogoPortfolioSlider from "../../../components/Sliders/LogoPortfolioSlider";
import TestimonialsSlider from "../../../components/Tools/Testimonials";
import { 
  FaCertificate, 
  FaAward, 
  FaFileContract, 
  FaUniversity, 
  FaBalanceScale,
  FaShieldAlt,
  FaRegFileAlt
} from "react-icons/fa";

const Aboutus = () => {
  const { title, description, keywords, canonical, ogImage } = seoData.aboutus;

  // Certifications data
  const certifications = [
    {
      icon: <FaCertificate className="text-3xl" />,
      title: "ISO Certified Council",
      description: "Internationally recognized quality management certification",
      badge: "Quality Certified"
    },
    {
      icon: <FaUniversity className="text-3xl" />,
      title: "NITI Aayog - Certificate of Enrollment",
      description: "Registered with Government of India's premier policy think tank",
      badge: "Govt. Registered"
    },
    {
      icon: <FaFileContract className="text-3xl" />,
      title: "Ministry of Social Justice & Empowerment",
      description: "Certificate of Enrolment with Government of India",
      badge: "Govt. Recognized"
    },
    {
      icon: <FaBalanceScale className="text-3xl" />,
      title: "LEI Certificate - Ministry of Corporate Affairs",
      description: "Legal Entity Identifier from Government of India",
      badge: "Legal Entity"
    },
    {
      icon: <FaAward className="text-3xl" />,
      title: "Registered by Govt. of Andhra Pradesh",
      description: "State Government registration and recognition",
      badge: "State Registered"
    },
    {
      icon: <FaShieldAlt className="text-3xl" />,
      title: "80G Certification - Income Tax Dept.",
      description: "Tax exemption for donors under Section 80G",
      badge: "Tax Exempt"
    },
    {
      icon: <FaRegFileAlt className="text-3xl" />,
      title: "12A Certification - Income Tax Dept.",
      description: "Tax exemption under Section 12A of Income Tax Act",
      badge: "Tax Exempt"
    }
  ];

  return (
    <div className="bg-gray-50 text-gray-900">
      {/* ===== SEO Meta Tags ===== */}
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="CRC Bharat" />
        <meta name="language" content="en" />
        <meta name="distribution" content="global" />

        {/* Open Graph */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={ogImage} />

        <link rel="canonical" href={canonical} />
      </Helmet>

      <main>
        {/* ===== About CRC Section ===== */}
        <section className="px-4 sm:px-6 lg:px-8 py-12 bg-white">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-bold text-center text-blue-900 mb-8">
              About CRC
            </h2>

            <div className="space-y-4 text-gray-700 text-base leading-relaxed  text-justify ">
              <p>
                Consumer Rights Council (CRC) is a national-level non-profit
                organization dedicated to promoting, protecting, and enforcing
                consumer rights under the Consumer Protection Act, 2019 and other
                relevant laws.
              </p>
              <p>
                CRC functions as an independent body to ensure fair trade
                practices, transparency, and accountability among service
                providers and manufacturers. It strengthens the consumer movement
                through legal intervention, advocacy, research, public education,
                and capacity-building activities.
              </p>
              <p>
                With National, State, and District Chapters, CRC provides legal
                guidance, assists in filing consumer complaints, and facilitates
                representation before Consumer Dispute Redressal Commissions and
                other authorities.
              </p>
              <p>
                CRC also conducts consumer awareness programs, workshops, and
                public campaigns. Collaborating with government departments and
                civil society organizations, it strives to create a fair and
                equitable marketplace for all consumers.
              </p>
            </div>
          </div>
        </section>

        {/* ===== Image Section ===== */}
        <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <img
            src={slider2}
            alt="About CRC team"
            className="w-full h-auto rounded-xl shadow-lg border border-gray-200"
          />
        </section>

        {/* ===== Vision & Mission Section ===== */}
        <section className="px-4 sm:px-6 lg:px-8 py-12 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-bold text-center text-blue-900 mb-10">
              Vision & Mission
            </h2>

            <div className="space-y-8">
              {/* Vision & Mission Grid */}
              <div className="grid md:grid-cols-2 gap-6">
                {/* Vision */}
                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                  <h3 className="text-xl text-center font-bold text-orange-600 mb-3">
                    Vision
                  </h3>
                  <p className="text-gray-700 leading-relaxed text-justify">
                    To establish a just, informed, and empowered consumer society
                    where every individual can exercise their rights with
                    confidence and responsibility.
                  </p>
                </div>

                {/* Mission */}
                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                  <h3 className="text-xl font-bold text-center text-orange-600 mb-3">
                    Mission
                  </h3>
                  <p className="text-gray-700 leading-relaxed  text-justify">
                    To promote consumer education, facilitate legal redressal, and
                    advocate for strong policy measures that uphold consumer
                    interests and ethical business conduct nationwide.
                  </p>
                </div>
              </div>

              {/* Core Objectives */}
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <h3 className="text-xl font-bold text-orange-600 mb-4 text-center">
                  Core Objectives
                </h3>
                <ul className="grid sm:grid-cols-2 gap-3 text-gray-700  text-justify">
                  <li className="flex items-start space-x-2 ">
                    <span className="text-orange-500 mt-1">•</span>
                    <span>Uphold & protect consumer rights under the Consumer Protection Act, 2019.</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <span className="text-orange-500 mt-1">•</span>
                    <span>Provide free legal aid, advice, and assistance in consumer disputes.</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <span className="text-orange-500 mt-1">•</span>
                    <span>Promote awareness about consumer rights, safety standards, and product integrity.</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <span className="text-orange-500 mt-1">•</span>
                    <span>Represent consumer interests before appropriate forums, commissions, and regulatory authorities.</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <span className="text-orange-500 mt-1">•</span>
                    <span>Collaborate with governmental and non-governmental agencies for effective consumer welfare initiatives.</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <span className="text-orange-500 mt-1">•</span>
                    <span>Encourage responsible consumer behavior and ethical market practices.</span>
                  </li>
                </ul>
              </div>

              {/* Motto */}
              <div className="text-center bg-gradient-to-r from-blue-50 to-orange-50 p-6 rounded-lg border border-gray-200">
                <h3 className="text-xl font-bold text-blue-900 mb-2">
                  Motto
                </h3>
                <p className="italic text-lg font-semibold text-gray-800">
                  "Empowered Consumers, Accountable Markets."
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ===== Certifications & Recognitions Section ===== */}
        <section className="px-4 sm:px-6 lg:px-8 py-16 bg-white">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl lg:text-4xl font-bold text-blue-900 mb-4">
                Certifications & Recognitions
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                CRC Bharat is officially recognized and certified by various government 
                bodies and international organizations, ensuring the highest standards 
                of service and credibility.
              </p>
            </div>

            {/* Certifications Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {certifications.map((cert, index) => (
                <div 
                  key={index}
                  className="bg-gradient-to-br from-white to-gray-50 rounded-xl shadow-md border border-gray-200 p-6 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
                >
                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0 text-blue-600">
                      {cert.icon}
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center justify-between mb-2">
                        <h3 className="font-bold text-gray-900 text-lg leading-tight">
                          {cert.title}
                        </h3>
                        <span className="bg-green-100 text-green-800 text-xs font-medium px-2 py-1 rounded-full">
                          {cert.badge}
                        </span>
                      </div>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        {cert.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Trust Badge */}
            <div className="mt-12 text-center">
              <div className="inline-flex items-center space-x-4 bg-blue-50 px-6 py-4 rounded-lg border border-blue-200">
                <FaShieldAlt className="text-3xl text-blue-600" />
                <div className="text-left">
                  <h4 className="font-bold text-blue-900 text-lg">
                    Trusted & Verified Organization
                  </h4>
                  <p className="text-blue-700 text-sm">
                    All certifications are verified and up-to-date with respective government authorities
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <LogoPortfolioSlider/>
      <TestimonialsSlider />
    </div>
  );
};

export default Aboutus;